import '../styles/styles.css';

import { initializePageHowItWorksModule } from '../lazy-pages/lazy-page-how-it-works';
import { initialModule } from '../modules/initial.module';
import { initializeLazyBgImageLoader } from '../modules/lazy-base/initialize-lazy-bg-loader';
import { initializeScrollToAnchor } from '../modules/lazy-base/initialize-scroll-to-anchor';
import { initializeCookiePopup } from '../modules/lazy-components/initialize-cookie-popup';
import { lazyFooter } from '../modules/lazy-components/initialize-footer';
import { initializeHeader } from '../modules/lazy-components/initialize-header';
import { initializeMobileMenu } from '../modules/lazy-components/initialize-mobile-menu';

// eslint-disable-next-line unicorn/prefer-top-level-await
(async () => {
  try {
    await initialModule.load();

    initializeScrollToAnchor();
    initializeLazyBgImageLoader();
    initializeCookiePopup();

    initializeHeader();
    initializeMobileMenu();
    lazyFooter.init();

    // Initialize specific page modules.
    initializePageHowItWorksModule();
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('🚨 Error loading main module:', error);
  }
})();
